import { render, staticRenderFns } from "./PostManager.vue?vue&type=template&id=8cc8d6ac&scoped=true"
import script from "./PostManager.vue?vue&type=script&lang=js"
export * from "./PostManager.vue?vue&type=script&lang=js"
import style0 from "./PostManager.vue?vue&type=style&index=0&id=8cc8d6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc8d6ac",
  null
  
)

export default component.exports